import { createSelector } from 'reselect';
// @ts-expect-error Untyped constants
import { HAS_SEEN_BLOG_PLG_ONBOARDING_TOUR } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
import { makeGetUserLocalSetting, getHasSeenOnboardingModalFromSuperStore
// @ts-expect-error Untyped module settingsSelectors
} from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
const getHasSeenOnboardingTour = makeGetUserLocalSetting(HAS_SEEN_BLOG_PLG_ONBOARDING_TOUR);
export const getShouldSeeOnboardingTour = createSelector([getHasSeenOnboardingTour, getHasSeenOnboardingModalFromSuperStore], (hasSeenOnboardingTour, hasSeenPatagoniaOnboardingModal) => {
  const isAcceptanceTest = window.SELENIUM_IS_RUNNING;
  return !isAcceptanceTest && !hasSeenOnboardingTour && !hasSeenPatagoniaOnboardingModal;
});